import React from "react";
import PropTypes from "prop-types";
import { Spinner, Button } from "react-bootstrap";

// Defaults live in the destructuring (function components no longer support the deprecated
// `defaultProps` — React logs a warning that the system-test harness flags as a SEVERE console error).
function SaveSpinnerButton({
  inactiveText = "Save",
  activeText = "Saving",
  isSaving = false,
  disabled = false,
  ...props
}) {
  return (
    <Button type="submit" {...props} disabled={disabled || isSaving}>
      <Spinner
        animation="border"
        className="me-2"
        role="status"
        variant="light"
        style={{
          width: "1.25rem",
          height: "1.25rem",
          display: `${isSaving ? "inline-block" : "none"}`,
        }}
      />
      {isSaving ? activeText : inactiveText}
    </Button>
  );
}

export default SaveSpinnerButton;

SaveSpinnerButton.propTypes = {
  inactiveText: PropTypes.string,
  activeText: PropTypes.string,
  isSaving: PropTypes.bool,
  disabled: PropTypes.bool,
};
